import React, { useEffect, useRef } from 'react';

import { FormInputText, pxToRem, useFormContext } from '@modernhealth/vital-components';

interface Props {
    labelledBy: string;
    placeholderText: string;
    validationText?: string;
    onAnswerChange: (value: number) => void;
    currentAnswer?: number;
    formFieldName: string;
}

export const NumberInputQuestion: React.FC<Props> = ({
    labelledBy,
    placeholderText,
    onAnswerChange,
    currentAnswer,
    formFieldName,
}) => {
    const formDefinition = useFormContext();
    const onAnswerChangeRef = useRef(onAnswerChange);
    onAnswerChangeRef.current = onAnswerChange;

    useEffect(() => {
        const subscription = formDefinition.watch(values => {
            onAnswerChangeRef.current(parseInt(values[formFieldName]));
        });

        return () => {
            subscription.unsubscribe();
        };
    }, [formDefinition, formFieldName]);

    return (
        <FormInputText
            css={{ width: pxToRem(500) }}
            name={formFieldName}
            type="number"
            placeholder={placeholderText}
            defaultValue={currentAnswer}
            labelledBy={labelledBy}
            trim
        />
    );
};
